export const bookingTypeListColumn = [
    {
        Header: 'Booking Id',
        accessor: 'bookingId',
    },
    {
        Header: 'Bookingtype Name',
        accessor: 'bookingtypeName',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    }
]

export const bookingTypeListTableData = [
    {
        "bookingId": "1101",
        "bookingtypeName": "Advance",
    },
    {
        "bookingId": "1102",
        "bookingtypeName": "Instant",
    },
    {
        "bookingId": "1103",
        "bookingtypeName": "Groups",
    },
    {
        "bookingId": "1104",
        "bookingtypeName": "Allocation",
    },
    {
        "bookingId": "1105",
        "bookingtypeName": "Business Seminar",
    },
    {
        "bookingId": "1106",
        "bookingtypeName": "Wedding",
    },
    {
        "bookingId": "1107",
        "bookingtypeName": "Birthday",
    },
    {
        "bookingId": "1108",
        "bookingtypeName": "Photoshoot",
    },
]